module.exports = __webpack_public_path__ + "docs/oven-factory-6588c8.md";